module.exports = "/images/Quest Room.svg?aab0236ffb077caa6b8dbdd7a04b2f32";